;(function ($) {
  "use strict";
  $(document).ready(function () {
    // close all help text fields not set to 'start-open'
    $('.form-help-content').each(function () {
      closeFormHelpContent($(this), true);
    });

    // bind toggle to buttons
    $(".form-help-toggle-holder button").on("click", function (e) {
      e.preventDefault();
      $(this).blur();

      var formHelpElem = $('#' + $(this).attr('aria-controls'));

      if (formHelpElem.hasClass("open")) {
        closeFormHelpContent(formHelpElem)
      } else {
        openFormHelpContent(formHelpElem);
      }
    });

  });
})(jQuery);


function openFormHelpContent(elem) {
  elem.show().animate({
    "height": elem.prop("scrollHeight")
  }, function () {
    elem.attr("aria-expanded", "true").addClass('open').css('height', '').focus();
  });
}

function closeFormHelpContent(elem, immediate) {
  if (immediate) {
    elem.attr("aria-expanded", "false").removeClass('open').css('height', 0).hide();
  } else {
    elem.animate({
      "height": 0
    }, function () {
      elem.attr("aria-expanded", "false").removeClass('open').hide();
    });
  }
}

